import MessagesPage from './messages-page'

export default MessagesPage
